/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./drawerLinksEdit.vue?vue&type=template&id=6311540c&scoped=true"
import script from "./drawerLinksEdit.vue?vue&type=script&lang=js"
export * from "./drawerLinksEdit.vue?vue&type=script&lang=js"
import style0 from "./drawerLinksEdit.vue?vue&type=style&index=0&id=6311540c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311540c",
  null
  
)

export default component.exports